/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OorPrerequisitesRequestDto
 */
export interface OorPrerequisitesRequestDto {
    /**
     * 
     * @type {string}
     * @memberof OorPrerequisitesRequestDto
     * @deprecated
     */
    modelId?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof OorPrerequisitesRequestDto
     */
    orgId?: string;
    /**
     * QVI service provider id who provides services for the workflow
     * @type {string}
     * @memberof OorPrerequisitesRequestDto
     */
    qviId?: string;
    /**
     * 
     * @type {string}
     * @memberof OorPrerequisitesRequestDto
     */
    scopedOrgId?: string;
}

/**
 * Check if a given object implements the OorPrerequisitesRequestDto interface.
 */
export function instanceOfOorPrerequisitesRequestDto(value: object): boolean {
    return true;
}

export function OorPrerequisitesRequestDtoFromJSON(json: any): OorPrerequisitesRequestDto {
    return OorPrerequisitesRequestDtoFromJSONTyped(json, false);
}

export function OorPrerequisitesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OorPrerequisitesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'modelId': json['modelId'] == null ? undefined : json['modelId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'qviId': json['qviId'] == null ? undefined : json['qviId'],
        'scopedOrgId': json['scopedOrgId'] == null ? undefined : json['scopedOrgId'],
    };
}

export function OorPrerequisitesRequestDtoToJSON(value?: OorPrerequisitesRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'modelId': value['modelId'],
        'orgId': value['orgId'],
        'qviId': value['qviId'],
        'scopedOrgId': value['scopedOrgId'],
    };
}

